export default "__VITE_ASSET__CSEKC8Rh__"